module.exports = __webpack_public_path__ + "5ea5a6463af13dd9f54a12063e9fcbed.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/calibre/calibre.woff2
// module id = 1573
// module chunks = 0